import { getReportGenerationFailure, getInsufficientSubmissionNumberError, getOngoingReportGenerationError, getMinimumThreeGradedSubmissionError, getNotEnoughDataAvailableError } from './errorMessages';
import { DEFAULT_ALERT_TIME } from '@instructure/quiz-common';
export var INSUFFICIENT_NUMBER_OF_SESSIONS = 'INSUFFICIENT_NUMBER_OF_SESSIONS';
export var ANALYSIS_GENERATION_IN_PROGRESS = 'ANALYSIS_GENERATION_IN_PROGRESS';
export var GENERAL_ANALYSIS_ERROR = 'GENERAL_ANALYSIS_ERROR';
export var NOT_ENOUGH_FULLY_GRADED_SUBMISSION = 'NOT_ENOUGH_FULLY_GRADED_SUBMISSION';
export var NOT_ENOUGH_FULLY_GRADED_QUESTION = 'NOT_ENOUGH_FULLY_GRADED_QUESTION';
export var getErrorMessageForCode = function getErrorMessageForCode(code) {
  var defaultMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  switch (code) {
    case INSUFFICIENT_NUMBER_OF_SESSIONS:
      return getInsufficientSubmissionNumberError();
    case ANALYSIS_GENERATION_IN_PROGRESS:
      return getOngoingReportGenerationError();
    case GENERAL_ANALYSIS_ERROR:
      return getReportGenerationFailure();
    case NOT_ENOUGH_FULLY_GRADED_SUBMISSION:
      return getMinimumThreeGradedSubmissionError();
    case NOT_ENOUGH_FULLY_GRADED_QUESTION:
      return getNotEnoughDataAvailableError();
    default:
      return defaultMsg;
  }
};
export var getAlertTimeoutMsForCode = function getAlertTimeoutMsForCode(code) {
  return code === INSUFFICIENT_NUMBER_OF_SESSIONS ? 10000 : DEFAULT_ALERT_TIME;
};